// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "home" + "." + "9070886ba6df51f1666e" + ".css";
};